const loadAerDec = () => {
  if (document.querySelector('.aer-dec-airbasin')) {
    const airBasinIMage = document.querySelector('.aer-dec-airbasin--image');

    const options = {
      threshold: .75,
      rootMargin: '0px 0px 0px 0px'
    };

    const airBasinObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          entry.target.classList.add('active');
          observer.unobserve(entry.target);
        }
      });
    }, options);

    airBasinObserver.observe(airBasinIMage);
  }

  if (document.querySelector('.aer-dec-finishes')) {
    const aerDecFinishesCard = document.querySelectorAll('.aer-dec-finishes--card');

    const options = {
      threshold: .25,
      rootMargin: '0px 0px 0px 0px'
    };

    const aerDecFinishesObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          entry.target.classList.add('active');
          observer.unobserve(entry.target);
        }
      });
    }, options);

    aerDecFinishesCard.forEach(aerDecFinishesCard => {
      aerDecFinishesObserver.observe(aerDecFinishesCard);
    });
  }

  if (document.querySelector('.aer-dec-width-mounting-type')) {
    const wrapper = document.querySelector('.aer-dec-width-mounting-type');
    const mountingTypes = document.querySelectorAll('.aer-dec-width-mounting-type--heading div');
    const mountingTypesImages = document.querySelectorAll('.aer-dec-width-mounting-type--images figure');

    const options = {
      threshold: .25,
      rootMargin: '0px 0px 0px 0px'
    };

    const mountingTypesObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          mountingTypes.forEach((mountingType, index) => {
            setTimeout(() => {
              mountingType.classList.add('active');
            }, index * 200);
          });
          mountingTypesImages.forEach((mountingType, index) => {
            setTimeout(() => {
              mountingType.classList.add('active');
            }, index * 200);
          });
          observer.unobserve(entry.target);
        }
      });
    } , options);

    mountingTypesObserver.observe(wrapper);
  }
};

export default loadAerDec;
